
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsad57bee119c12e894272f13179da0a9ben from './en.yaml'
            i18n.addResourceBundle('en', 'ad57bee119c12e894272f13179da0a9b', flattenObject(nsad57bee119c12e894272f13179da0a9ben), true, true);
        
        export default 'ad57bee119c12e894272f13179da0a9b';
    